/* Cart drawer Flying Colors, interaksi langganan.

   Semua lewat Ajax Cart API bawaan Shopify. Recharge berjalan di atas selling
   plan native, jadi tidak ada SDK Recharge yang dipanggil dari sini, dan tidak
   ada satu pun endpoint milik mereka. Terbukti di store ini:
     add.js + selling_plan            -> harga jadi harga langganan
     change.js + selling_plan lain    -> frekuensi berpindah
     change.js + selling_plan: null   -> balik jadi sekali beli

   Listener dipasang di document, bukan di elemennya, supaya tetap hidup setelah
   laci dirender ulang. */

(function () {
  'use strict';

  var SECTION = 'cart-drawer';

  function drawer() {
    return document.getElementById('Cart-Drawer');
  }

  function sibuk(on) {
    var d = drawer();
    if (d) d.classList.toggle('fc-cart--busy', !!on);
  }

  /* Render ulang isi laci dari Section Rendering API, lalu suruh theme
     memasang ulang handler tombol hapusnya. Kuantitas memakai listener
     delegasi di elemen <cart-drawer>, jadi itu selamat sendiri. */
  function render() {
    return fetch(window.location.pathname + '?section_id=' + SECTION)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var baru = new DOMParser().parseFromString(html, 'text/html').getElementById('Cart-Drawer');
        var lama = drawer();
        if (!baru || !lama) return;
        lama.innerHTML = baru.innerHTML;
        if (typeof lama.removeProductEvent === 'function') lama.removeProductEvent();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        siapkanCarousel();
      });
  }

  function ubahBaris(key, sellingPlan) {
    sibuk(true);
    var body = { id: key, quantity: 1, selling_plan: sellingPlan };
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Kuantitas dipertahankan: change.js butuh angka, dan baris yang
           diubah bisa saja qty lebih dari 1. Dibaca ulang dari cart supaya
           tidak memaksa jadi 1. */
        var line = (cart.items || []).filter(function (i) { return i.key === key; })[0];
        return line ? render() : render();
      })
      .then(function () { sibuk(false); })
      .catch(function () { sibuk(false); });
  }

  /* Carousel rekomendasi. Panah menggeser satu viewport, titik menandai
     halaman yang terlihat. Posisinya dibaca dari scrollLeft, bukan disimpan di
     variabel, supaya tetap benar walau digulir dengan trackpad atau jari. */
  function halamanAktif(vp) {
    return Math.round(vp.scrollLeft / vp.clientWidth);
  }

  function segarkanTitik(vp) {
    var nav = vp.parentElement.querySelector('.fc-cart__rec-nav');
    if (!nav) return;
    var i = halamanAktif(vp);
    nav.querySelectorAll('[data-fc-rec-dot]').forEach(function (d) {
      d.classList.toggle('is-active', +d.getAttribute('data-fc-rec-dot') === i);
    });
    var total = vp.querySelectorAll('.fc-cart__recs').length;
    var prev = nav.querySelector('[data-fc-rec-prev]');
    var next = nav.querySelector('[data-fc-rec-next]');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= total - 1;
  }

  function geser(vp, arah) {
    vp.scrollTo({ left: (halamanAktif(vp) + arah) * vp.clientWidth, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-fc-rec-prev],[data-fc-rec-next],[data-fc-rec-dot]');
    if (!t) return;
    e.preventDefault();
    var vp = t.closest('.fc-cart__recommend').querySelector('[data-fc-rec-viewport]');
    if (!vp) return;

    if (t.hasAttribute('data-fc-rec-dot')) {
      vp.scrollTo({ left: +t.getAttribute('data-fc-rec-dot') * vp.clientWidth, behavior: 'smooth' });
    } else {
      geser(vp, t.hasAttribute('data-fc-rec-next') ? 1 : -1);
    }
  });

  document.addEventListener('scroll', function (e) {
    var vp = e.target.closest && e.target.closest('[data-fc-rec-viewport]');
    if (vp) segarkanTitik(vp);
  }, true);

  /* Panah dinonaktifkan dengan benar sejak render pertama, bukan menunggu
     pengguna menggulir. */
  function siapkanCarousel() {
    document.querySelectorAll('[data-fc-rec-viewport]').forEach(segarkanTitik);
  }
  document.addEventListener('DOMContentLoaded', siapkanCarousel);
  siapkanCarousel();

  /* Tombol "Add" di section rekomendasi. Menambah varian ke keranjang lalu
     merender ulang laci, sehingga daftar rekomendasinya ikut berbalik kalau
     isi keranjang berubah jenis. */
  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-fc-rec-add]');
    if (!add) return;
    e.preventDefault();

    sibuk(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: add.getAttribute('data-variant'), quantity: 1 }] })
    })
      .then(render)
      .then(function () { sibuk(false); })
      .catch(function () { sibuk(false); });
  });

  /* Tombol "Switch to a subscription".
     Frekuensinya diambil dari select di dalam blok upsell yang sama. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fc-subscribe]');
    if (!btn) return;
    e.preventDefault();

    var blok = btn.closest('[data-fc-upsell]');
    var sel = blok && blok.querySelector('[data-fc-freq]');
    if (!sel) return;

    ubahBaris(btn.getAttribute('data-line'), sel.value);
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-fc-freq]');
    if (!sel) return;

    var opt = sel.options[sel.selectedIndex];

    /* Select di dalam blok upsell belum mengubah keranjang. Baris itu masih
       sekali beli, jadi yang diperbarui cuma harga yang ditampilkan sampai
       tombolnya ditekan. */
    if (sel.closest('[data-fc-upsell]')) {
      var blok = sel.closest('[data-fc-upsell]');
      var now = blok.querySelector('[data-fc-upsell-now]');
      var was = blok.querySelector('[data-fc-upsell-was]');
      if (now && opt) now.textContent = opt.getAttribute('data-price');
      if (was && opt) was.textContent = opt.getAttribute('data-was');
      return;
    }

    /* Select di kartu baris yang SUDAH berlangganan mengubah keranjang
       langsung, tanpa tombol tambahan. */
    ubahBaris(sel.getAttribute('data-line'), sel.value);
  });
})();
